function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12.9283 0.606934C13.1945 0.340667 13.6268 0.340667 13.8931 0.606934C14.1295 0.843615 14.1552 1.21047 13.9712 1.47607L13.8931 1.5708L8.46048 7.00244L13.8931 12.4351C14.1593 12.7013 14.1593 13.1336 13.8931 13.3999C13.6565 13.6365 13.2887 13.6629 13.023 13.479L12.9283 13.3999L7.49564 7.96729L2.064 13.3999C1.79783 13.666 1.3664 13.6658 1.10013 13.3999C0.863447 13.1632 0.836941 12.7955 1.02103 12.5298L1.10013 12.4351L6.53177 7.00244L1.10013 1.5708C0.833862 1.30453 0.833862 0.8732 1.10013 0.606934C1.33678 0.370345 1.70357 0.343849 1.96927 0.527832L2.064 0.606934L7.49564 6.03857L12.9283 0.606934Z",
  fill: "currentColor"
});

var SvgClose = function SvgClose(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 15 14",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgClose, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/close.464048f0.svg";
export { ForwardRef as ReactComponent };